import axios from 'Src/helpers/api/axiosInstance';
import { AppUser } from 'Src/views/App/App';

type ModuleStatus = 'ACTIVE' | 'INACTIVE' | 'TRIAL' | 'ACTIVE_FULL' | 'ACTIVE_TRIAL' | 'ACTIVE_INCLUDED';

export interface ModuleSubscriptionRequest {
  _id: string;
  type: 'TRIAL' | 'FULL';
  targetStatus: ModuleStatus;
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED';
  requestedAt?: string | Date;
  processedAt?: string | Date;
}

export interface ModuleSubscription {
  module: string;
  status: ModuleStatus;
  validFrom?: string | Date;
  validUntil?: string | Date;
  isTrialAvailable?: boolean;
  description?: string;
  note?: string;
  includedWithModule?: string;
  trialEverActivated?: boolean;
  trialLastEndedAt?: string | Date;
  requests?: ModuleSubscriptionRequest[];
}

export function getSchoolModules(user: AppUser): Promise<ModuleSubscription[]> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .get(`${(window as any).apiBase}/i/schools/${activeSchoolId}/modules`, config)
    .then(response => response.data);
}

export function createModuleSubscriptionRequest(
  user: AppUser,
  moduleKey: string,
  requestType: 'TRIAL' | 'FULL',
  targetStatus: 'ACTIVE' | 'TRIAL',
  messageFromSchool?: string
): Promise<{ subscription: ModuleSubscription; request: ModuleSubscriptionRequest }> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  const data = {
    requestType,
    targetStatus,
    messageFromSchool
  };

  return axios
    .post(`${(window as any).apiBase}/i/schools/${activeSchoolId}/modules/${moduleKey}/requests`, data, config)
    .then(response => response.data);
}
